
import TitleBox from '@/components/CSS/TitleBox'
import PzGoodsInfo from '@/components/Bargain/pz-goods-info'
import BargainSteps from '@/components/Bargain/steps'
import QuotationHistory from './components/quotationHistory.vue'
import GoodsListPage from '@/components/GoodsListPage'
import SellerEmpty from '@/components/Bargain/seller/Empty'
import BargainSellerItem from '@/components/Bargain/seller/dialog'
const BargainSetting = () => import('@/components/Bargain/seller/bargainSetting')
export default {
	components: {
		TitleBox,
		PzGoodsInfo,
		BargainSteps,
		QuotationHistory,
		GoodsListPage,
		SellerEmpty,
		BargainSellerItem
	},
	data() {
		return {
			// 用于买卖家场景展示不同的数据信息
			role: {
				WAITING_FOR_BUYER_RESPONSE: {
					cn: '我的还价',
					en: 'sellerPrice',
					sub: '买家',
					color: '#0082E6'
				},
				WAITING_FOR_SELLER_RESPONSE: {
					cn: '买家报价',
					en: 'buyerPrice',
					sub: '卖家',
					color: '#13BF78'
				}
			},
			// 当前砍价列表
			bargainList: [],
			// 分页器数据
			pageInfo: {
				page: 1,
				pageSize: 10,
				total: 0
			},
			loading: false,
			dialogVisible: false,
			dialogParams: {},
			dialogData: {},
			tabsList: [
				{
					label: '当前砍价',
					name: 'CURRENT'
				},
				{
					label: '历史砍价',
					name: 'HISTORY'
				}
			],
			tabsListSecond: {
				CURRENT: [
					{
						label: '全部',
						name: 'NULL'
					},
					{
						label: '砍价中',
						name: 'IN_PROGRESS'
					},
					{
						label: '砍价成功',
						name: 'SUCCESS'
					}
				]
			},
			tabsListThird: {
				SUCCESS: [
					{
						label: '买家已支付',
						name: 'PAID'
					},
					{
						label: '待买家支付',
						name: 'NOT_PAID'
					}
				]
			},
			active: ['CURRENT', 'NULL', 'PAID'],
			detailInfo: {},
			// 筛选项：
			sortValue: null,
            sortValueNow: null,
            sortValueHistory: null,
			dropdownShow: false,
			dropdownMap: {
				creatTime: '报价时间最近',
				buyerPrice: '报价金额最高'
			},
			bargainConfig: {},
			badgeStyle: { right: '-8px', transform: 'translateY(-50%) translateX(0)', animation: 'none' }
		}
	},
	mounted() {
		this.getDetailInfo()
		this.initList()
		this.setMenuDot()
	},
	methods: {
		/**
		 * 设置小红点
		 */
		async setMenuDot() {
			const par = {
				action: {
					buyer: false,
					goodsNo: this.detailInfo.goodsNo
				}
			}
			const res = await this.$api.getBargainDot(par)
			const { bargainFailedDotNum, bargainInProgressDotNum, bargainPayCancel, bargainPayedDotNum, bargainPayingDotNum, bargainSuccessDotNum } = res.data
			this.tabsList = [
				{
					label: '当前砍价',
					name: 'CURRENT',
					dot: bargainInProgressDotNum + bargainSuccessDotNum
				},
				{
					label: '历史砍价',
					name: 'HISTORY',
					dot: bargainPayCancel + bargainFailedDotNum
				}
			]
			this.tabsListSecond = {
				CURRENT: [
					{
						label: '全部',
						name: 'NULL'
					},
					{
						label: '砍价中',
						name: 'IN_PROGRESS',
						dot: bargainInProgressDotNum
					},
					{
						label: '砍价成功',
						name: 'SUCCESS',
						dot: bargainSuccessDotNum
					}
				]
			}
			this.tabsListThird = {
				SUCCESS: [
					{
						label: '买家已支付',
						name: 'PAID',
						dot: bargainPayedDotNum
					},
					{
						label: '待买家支付',
						name: 'NOT_PAID',
						dot: bargainPayingDotNum
					}
				]
			}
		},
		// 点击筛选详
		dropdownClick(value) {
			if (this.sortValue === value) return
			this.sortValue = value
            if (this.active[0] === 'CURRENT') {
				this.sortValueNow = value
			} else {
				this.sortValueHistory = value
			}
			this.initList()
		},
		// 判断是否展示dropdown
		dropdownChange(show) {
            this.sortValue = this.active[0] === 'CURRENT' ? this.sortValueNow : this.sortValueHistory;
			this.dropdownShow = show
		},
		// 获取报价设置
		getBargainConfig() {
			this.$api
				.bargainUserGoodsConfigApi({
					action: {
						goodsNo: this.detailInfo.goodsNo
					}
				})
				.then(res => {
					if (res.success) {
						this.bargainConfig = res.data || {}
					}
				})
		},
		// 唤起报价设置弹窗
		onSetBargain() {
			const model = this.$pzDialog(
				{
					title: '报价设置',
					width: '450px',
					top: '15vh',
					cancelButtonText: '取消',
					confirmButtonText: '保存',
					showFooter: false,
					showClose: true,
					component: BargainSetting,
					customClass: 'bargain-setting-dialog',
					componentData: {
						gameId: this.detailInfo.gameId,
						goodsCatalogueId: this.detailInfo.goodsCatalogueId,
						goodsNo: this.detailInfo.goodsNo,
						goodsPrice: this.detailInfo.price,
						autoRefuse: this.bargainConfig.autoRefuse || false,
						autoRefusePrice: this.bargainConfig.autoRefusePrice || 0,
						autoData: {
							autoAgree: this.bargainConfig.autoAgree || false,
							autoAgreePrice: this.bargainConfig.autoAgreePrice || 0
						},
						limitPrice: this.bargainConfig.limitPrice
					},
					onConfirm: (isRemove = true) => {
						isRemove && model.remove()
						this.getBargainConfig()
					},
					onCancel: () => {
						model.remove()
					}
				},
				this
			)
		},
		async getDetailInfo() {
			const { goodsNo } = this.$route.query
			try {
				const par = {
					action: { goodsNo }
				}
				const res = await this.$api.bargainSellerGoodsInfo(par)
				if (!res.success) return this.$message.error(res.info)
				this.detailInfo = res.data
				this.getBargainConfig()
			} catch (err) {
				this.$message.error(err.message)
			}
		},
		/**
		 * 清除小红点
		 */
		async onClearBargainDot(scene) {
			if (!this.active) return
			const par = {
				action: {
					buyer: false,
					scene,
					goodsNo: this.detailInfo.goodsNo
				}
			}
			const res = await this.$api.clearBargainDot(par)
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			await this.$store.dispatch('menu/onSetCenterDotMenu', {
				menu: this.centerMenu,
				userAccount: this.userAccount
			})
		},
		async getCurrentList() {
			const { goodsNo } = this.$route.query
			this.loading = true
			try {
				const par = {
					action: {
						goodsNo
					},
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					sort: this.sortValue
				}
				if (this.active[1] !== 'NULL') {
					par.action.status = this.active[1]
					if (this.active[1] === 'SUCCESS') {
						par.action.bargainOrderPayStatus = this.active[2]
					}
				}
				const res = await this.$api.bargainSellerCurrentList(par)
				this.loading = false
				if (!res.success) return this.$message.error(res.info)
				const { records, page, total } = res.data
				this.pageInfo.page = page
				this.pageInfo.total = Number(total)
				this.bargainList = records
			} catch (err) {
				this.loading = false
				this.$message.error(err.message)
			}
		},
		/**
		 * 获取历史砍价数据
		 * @param {*} goodsNo
		 */
		async getHistoryData() {
			try {
				const { goodsNo } = this.$route.query
				this.loading = true
				const par = {
					action: {
						goodsNo
					},
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					sort: this.sortValue
				}
				const res = await this.$api.bargainSellerHistoryList(par)
				this.loading = false
				if (!res.success) return this.$message.error(res.info)
				const { records, page, total } = res.data
				this.pageInfo.page = page
				this.pageInfo.total = Number(total)
				this.bargainList = records
			} catch (err) {
				this.loading = false
				this.$message.error(err.message)
			}
		},
		/**
		 * 根据砍价状态展示不同的操作按钮及业务逻辑
		 * @param {*} e
		 */
		formatterBtns(e) {
			let btns = []
			switch (e?.status) {
				case 'IN_PROGRESS':
					if (e?.substatus === 'WAITING_FOR_SELLER_RESPONSE') {
						btns = [
							{
								name: '拒绝',
								type: '',
								handleClick: el => {
									this.dialogParams = {
										title: '拒绝报价',
										type: 'REFUSE'
									}
									this.dialogData = { ...el, title: this.detailInfo.title || el.title, simpleMessage: this.detailInfo.simpleMessage || el.simpleMessage }
									this.dialogVisible = true
								}
							},
							{
								name: '还价',
								type: '',
								handleClick: el => {
									this.dialogParams = {
										title: '还价',
										type: 'COUNTER'
									}
									this.dialogData = { ...el, title: this.detailInfo.title || el.title, simpleMessage: this.detailInfo.simpleMessage || el.simpleMessage }
									this.dialogVisible = true
								}
							},
							{
								name: '同意报价',
								type: 'danger',
								handleClick: el => {
									this.dialogParams = {
										title: '同意报价',
										type: 'AGREE'
									}
									this.dialogData = { ...el, title: this.detailInfo.title || el.title, simpleMessage: this.detailInfo.simpleMessage || el.simpleMessage }
									this.dialogVisible = true
								}
							}
						]
					}
					if (e?.substatus === 'WAITING_FOR_BUYER_RESPONSE') {
						btns = [
							{
								name: '结束砍价',
								type: '',
								handleClick: el => {
									this.dialogParams = {
										title: '结束砍价',
										type: 'CANCEL'
									}
									this.dialogData = { ...el, title: this.detailInfo.title || el.title, simpleMessage: this.detailInfo.simpleMessage || el.simpleMessage }
									this.dialogVisible = true
								}
							}
						]
					}
					break
				case 'SUCCESS':
					if (e?.bargainOrderPayStatus === 'PAID') {
						btns = [
							{
								name: '联系客服',
								type: Number(e.bargainSuccessSale) === 0 ? '' : 'danger',
								handleClick: async el => {
									this.dialogData = { ...el }
									try {
										const par = {
											action: {
												bargainId: el.id
											}
										}
										const res = await this.$api.getBargainLinkCustomer(par)
										if (!res.success) return this.$message.error(res.info)
										const { linkGroup } = res.data
										// 唤起IM群聊
										this.$store.dispatch('ry/join', { targetId: linkGroup, conversationType: 3 })
									} catch (err) {
										this.$message.error(err.message)
									}
								}
							}
						]
					}
					break
				default:
					break
			}
			return btns
		},
		/**
		 *currentPage 页码值改变时触发事件
		 */
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getDataList()
		},
		/**
		 * pageSize 每页展示数据条数改变时触发事件
		 */
		handleSizeChange(pageSize) {
			this.pageInfo = { page: 1, pageSize }
			this.getDataList()
		},
		/**
		 * 关闭弹窗
		 */
		onClose() {
			this.dialogVisible = false
		},
		// tab切换
		async onChangeTabs(item, index) {
			if (this.active[index] === item.name) return
			if (index === 0) {
				this.active = [item.name, 'NULL', 'PAID']
                this.sortValue = item.name === 'CURRENT' ? this.sortValueNow : this.sortValueHistory;
				if (item.name === 'HISTORY') {
					this.onClearBargainDot('FAILED')
				}
			} else if (index === 1) {
				this.active = [this.active[0], item.name, 'PAID']
				if (item.name === 'SUCCESS') {
					this.onClearBargainDot('PAID')
				}
			} else if (index === 2) {
				this.active = [this.active[0], this.active[1], item.name]
				if (item.name === 'PAID') {
					this.onClearBargainDot('PAID')
				}
			}
			this.$store.dispatch('user/UserCenterStatistics')
			this.setMenuDot()
			this.initList()
		},
		// 初始化列表
		initList() {
			this.pageInfo.page = 1
			this.pageInfo.total = 0
			this.getDataList()
		},
		// 获取列表
		getDataList() {
			if (this.active[0] === 'CURRENT') {
				this.getCurrentList()
			} else {
				this.getHistoryData()
			}
		}
	}
}
